<div class="container">
	<mat-card class="main-card">
		<mat-card-content class="card-content">
			<h3 class="title">{{ 'forgot_page.title' | translate }}</h3>

			<form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="login-form">
				<mat-form-field appearance="fill" class="full-width">
					<mat-label>{{ 'forgot_page.email_label' | translate }}</mat-label>
					<input matInput formControlName="email" [placeholder]="'forgot_page.email_placeholder' | translate" type="email" />
				</mat-form-field>

				<div>
					<button mat-raised-button type="submit" class="submit-button full-width">
						{{ 'forgot_page.send_link' | translate }}
					</button>
				</div>

				<div class="redirect">
					<a (click)="goToLogin()">{{ 'forgot_page.back_to_login' | translate }}</a>
				</div>
			</form>
		</mat-card-content>

		<div class="side-content">
			<div class="logo" style="background-image: url('https://dev-admin.smoothr.de/img/smoothr_logo.def9972e.svg')"></div>
			<p class="description">{{ 'login_page.short_info' | translate }}</p>
		</div>
	</mat-card>
</div>
